import { render, staticRenderFns } from "./CardknoxIFieldsKey.vue?vue&type=template&id=237bb9ee&"
import script from "./CardknoxIFieldsKey.vue?vue&type=script&lang=ts&"
export * from "./CardknoxIFieldsKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports